import React from "react";
import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

import moment from "moment";

import { MONTHS } from "./utils";

const CalendarInputHeader = ({ date, handleSetMonth }) => (
  <div className="calendar-header">
    <Button size="small" onClick={handleSetMonth(-1)}>
      <Icon>
        <FontAwesomeIcon icon="arrow-left" />
      </Icon>
    </Button>
    <h4 className="calendar-title">
      <span className="month">{MONTHS[moment(date).month()]}</span>
      <span className="year">{moment(date).year()}</span>
    </h4>
    <Button size="small" onClick={handleSetMonth(1)}>
      <Icon>
        <FontAwesomeIcon icon="arrow-right" />
      </Icon>
    </Button>
  </div>
);

CalendarInputHeader.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment)
  ]),
  handleSetMonth: PropTypes.func
};
export default CalendarInputHeader;
